import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export { BACKEND_URL };
export const LOGO_URL = "/tbb-logo.png";

// Create an axios-like helper for auth headers
export const getAuthHeaders = () => {
  const token = localStorage.getItem("session_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Configure axios interceptor to auto-attach auth headers
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("session_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.withCredentials = true;
  return config;
});

// Handle 401 responses globally — clear stale token
// Handle 402 responses globally — open global upgrade modal
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Don't redirect during OAuth callback or on login page
      const isCallback = window.location.hash?.includes("session_id=");
      const isLogin = window.location.pathname.includes("/login");
      if (!isCallback && !isLogin) {
        localStorage.removeItem("session_token");
      }
    }
    if (error.response?.status === 402) {
      // Broadcast a global event so the app can open the UpgradeModal.
      try {
        const detail = {
          reason: "out_of_credits",
          message: error.response?.data?.detail || "Insufficient credits",
        };
        window.dispatchEvent(new CustomEvent("open-upgrade-modal", { detail }));
      } catch (_) {}
    }
    return Promise.reject(error);
  }
);
